import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Box, Flex } from '../../../../units/Box/Box';
import Text from '../../../../units/Text/Text';
import Button from '../../../../units/Button/Button';

const errors = {
  CANCEL_OPERATION: {
    title: 'Операция отменена',
    message: 'Операция отменена'
  },
  CANCEL_OPERATION_BY_USER: {
    title: 'Операция отменена',
    message: 'Операция отменена пользователем'
  },
  PLUGIN_NOT_FOUND: {
    title: 'Плагин не найден',
    message: 'Работа с плагином невозможна'
  },
  SIGN_IMPOSSIBLE_WO_PLUGIN: {
    title: 'Плагин не найден',
    message: 'Работа с электронной подписью без плагина невозможна'
  },
  PLUGIN_NEED_INSTALL: {
    title: 'Плагин не найден',
    message: 'Работа с ЭП будет возможна только после установки плагина'
  },
  ACTIVE_CERTIFICATE_NOT_FOUND: {
    title: 'Проверка сертификата',
    message: 'Активный сертификат не найден'
  }
};

class ErrorForm extends Component {
  static propTypes = {
    renderHeader: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
    applyAction: PropTypes.func.isRequired,
    fields: PropTypes.object.isRequired
  };

  ok = () => {
    const { actions, applyAction } = this.props;
    const actionId = actions._yes ? '_yes' : actions._ok ? '_ok' : '_close';

    applyAction({
      actionId
    });
  };

  render() {
    const { fields } = this.props;

    const errorCode = fields.code.value;

    const defaultTitle = fields.title.value;
    const defaultMessage = fields.message.value;

    const title =
      errorCode && errors[errorCode] ? errors[errorCode].title : defaultTitle;
    const message =
      errorCode && errors[errorCode]
        ? errors[errorCode].message
        : defaultMessage;

    return (
      <Box>
        {this.props.renderHeader({
          title
        })}
        <Box maxw="300px" className="modal-error__message">
          <Text height="20px" size="16px">
            {message}
          </Text>
        </Box>

        <Flex mt="18px" justify="flex-end">
          <Button onClick={this.ok}>Закрыть</Button>
        </Flex>
      </Box>
    );
  }
}

export default ErrorForm;



// WEBPACK FOOTER //
// ./src/components/containers/Forms/FormsComponents/ErrorDialog/ErrorDialog.js